import { Box, SpacerNew } from '@jfs/ui-new'
import React, { FC } from 'react'
import { DownloadFileComp } from '../UploadedFileDetails/DownloadFileComp'
import { styles } from './styles'

interface DownloadViewCompProps {
  onDownloadPress: (item: any) => void
  onViewPress: (item: any) => void
}

const DownloadViewComp: FC<DownloadViewCompProps> = React.memo(
  ({ onDownloadPress, onViewPress }: DownloadViewCompProps) => {
    return (
      <Box {...styles.rowContainer}>
        <DownloadFileComp type={'download'} title={'Download File'} onButtonPress={onDownloadPress} />
        <SpacerNew size={20} direction={'horizontal'} />
        <DownloadFileComp type={'View'} title={'View'} onButtonPress={onViewPress} />
      </Box>
    )
  },
)

export { DownloadViewComp }
